import moment from "moment";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { searchService } from "../../services/searchService";
import settings from "../../settings";
import "./Search.scss";
import SearchBar from "./SearchBar";
import SearchResult from "./SearchResult";
import flatMap from "lodash/flatMap";
import sortBy from "lodash/sortBy";
import random from "lodash/random";
import { generateSearchLink, getReplacedTag, getTagsIndex } from "../../helpers/urls";
import swal from "sweetalert";
import { checkForArabic } from "../../helpers/arabicLangValidator";
import { Helmet } from "react-helmet";
import {Link} from "react-router-dom";
import ShortDescription from "./ShortDescription";
import _ from "lodash";
import TrustPilot2 from "../review/TrustPilot2";
import { SearchContext } from "../../context/SearchContext";
import { checkAreaMatchesForDescription } from "../../settings";

class Search extends Component {
  static contextType = SearchContext;
  constructor(props) {
    super(props);
    this.listingRef = React.createRef();

    const params = new URLSearchParams(this.props.location.search);
    const page = params.get("page");
    const from = params.get("from");
    const to = params.get("to");
    const guests = params.get("guests");
    const bedrooms = params.get("bedrooms");
    const searchText = params.get("searchText");
    const sort = params.get("sort");

    const parsedBedrooms = bedrooms?.length > 0 ? bedrooms.split(",") : [];

    this.state = {
      searchByNameVisible: false,
      city: {},
      guests: guests ? parseInt(guests) : 1,
      startDate: from ? moment(from) : null,
      endDate: to ? moment(to) : null,
      cities: settings.citiesTags
        .filter(({ visible }) => visible)
        .map((city) => city),
      tags: this.getUrlTags(),
      properties: [],
      mapProperties: [],
      bedrooms: settings.bedrooms.filter((bedroom) =>
        parsedBedrooms.includes(bedroom.name)
      ),
      totalProperties: 0,
      sortMethod:
        settings.sortMethods.find((method) => sort === method.translationKey) ||
        settings.sortMethods[0],
      page: page ? page : 1,
      searchText: searchText ? searchText : "",
      downloadingItems: true,
      downloadingMapItems: true,
      getListingParams: {},
    };
  }

  async componentDidMount() {
    const pathName = this.props.match.params.city;
    await this.selectCityFromParam(pathName);
  }

  async componentDidUpdate(prevProps, prevState) {
    if (
      this.props.t !== prevProps.t ||
      this.state.city !== prevState.city ||
      this.props.location.pathname !== prevProps.location.pathname
    ) {
      this.setState({
        tags: await this.getUrlTags(),
      });
    }
    if (this.props.location.pathname !== prevProps.location.pathname) {
      const pathName = this.props.match.params.city;
      // Reset page to 1 when city changes
      if (this.props.match.params.city !== prevProps.match.params.city) {
        this.setState({ page: 1 }, async () => {
          await this.selectCityFromParam(pathName);
        });
      } else {
        await this.selectCityFromParam(pathName);
      }
    }
    if (this.props.location.search !== prevProps.location.search) {
      if (this.props.location.search === "") {
        this.setState(
          {
            bedrooms: [],
            guests: 1,
            page: 1,
            searchText: "",
            endDate: null,
            startDate: null,
          },
          () => {
            this.onSearchClick();
          }
        );
      }
    }
  }

  getUrlTags() {
    const tags = this.props.match.params.paramValue;
    const parsedTags = tags?.length > 0 ? tags.split(",") : [];

    let tagsToMap = [
      ...settings.tagsDubai,
      ...settings.tagsAbuDhabi,
      ...settings.tagsStpetersburg,
    ];
    if (this.state?.city?.urlName) {
      tagsToMap = settings[getTagsIndex(this.state.city.urlName)];
    }

    return tagsToMap
      .filter((tag) => parsedTags.includes(tag.slug))
      .map((tag) => ({
        tag: tag.tag,
        displayName: this.props.t(tag.translationKey),
        slug: tag.slug,
      }));
  }

  selectCityFromParam(selectedCity) {
    const foundCity = settings.citiesTags
      .filter(({ visible }) => visible)
      .find((c) => c.urlName === selectedCity?.toLowerCase());
    const city = foundCity
      ? foundCity
      : settings.citiesTags.filter(({ visible }) => visible)[0];
    this.setState({ city, page: 1 }, async () => {
      await this.props.onCityUpdate(city);
      await this.onSearchClick();
    });
  }

  onGuestChange(guests) {
    this.setState({
      guests: guests > 0 ? guests : 1,
      page: 1,
    });
  }

  onBedroomsChange(bedrooms) {
    this.setState({
      bedrooms: bedrooms,
      page: 1,
    });
  }

  onCityClick(city) {
    this.setState({ city: city, tags: [], page: 1 }, () => {
      this.onSearchClick();
    });
  }

  onChangeHandler(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  onDatesChange({ startDate, endDate }) {
    this.setState({ startDate, endDate, page: 1 }, () => {
      if ((startDate !== null && endDate !== null )|| (startDate === null && endDate === null)) {
        this.onSearchClick();
      }
    });
  }

  onSortSelect(method) {
    this.setState({ sortMethod: method, page: 1 }, () => {
      this.onSearchClick(false);
    });
  }

  onTagsChange(tags) {
    this.setState({ tags, page: 1 });
  }

  onChangePage(page) {
    this.setState({ page: page }, () => {
      this.onSearchClick(false);
    });
  }

  onSearchClickEvent(event) {
    if (event) {
      event.preventDefault();
    }

    this.setState({}, () => {
      this.onSearchClick();
    });
  }

  handleShuffleIfNeeded(list, isDefault) {
    if (isDefault) {
      return sortBy(list, (item) =>
        item.tags.includes("TOP_STAR") ? 0 : random(1, 100)
      );
    }
    return list;
  }

  /** Map API can omit STAR/default first-page listings; merge list page into map markers without duplicate ids. */
  mergeFirstPageListIntoMapProperties(mapResults, listResults) {
    const keyOf = (p) =>
      String(p.property_id ?? p._id ?? p.id ?? "");
    const merged = new Map();
    (mapResults || []).forEach((p) => {
      const k = keyOf(p);
      if (k) merged.set(k, p);
    });
    (listResults || []).forEach((p) => {
      const k = keyOf(p);
      if (!k || merged.has(k)) return;
      merged.set(k, {
        ...p,
        property_id: p.property_id ?? p._id,
      });
    });
    return Array.from(merged.values());
  }

  onSearchClick = async (getMapProperties = true) => {
    this.props.onCityUpdate(this.state.city);
    const { city: cityName, paramValue: cityTags = undefined } =
      this.props.match.params;
    this.props.getDetailTitle({ city: cityName, tags: cityTags });
    const {
      city,
      startDate,
      endDate,
      guests,
      sortMethod,
      page,
      tags,
      searchText,
      bedrooms,
    } = this.state;

    const paramsForDefaultPage = {
      checkIn: startDate ? startDate.format("YYYY-MM-DD") : null,
      checkOut: endDate ? endDate.format("YYYY-MM-DD") : null,
      guests,
      sort: sortMethod || null,
      page: parseInt(page, 10),
      tags: tags.map((tag) => tag.tag),
      bedrooms: flatMap(bedrooms, (b) => b.values),
      searchText,
    };

    // ✅ define getListingParams in the same scope you use it
    let getListingParams = {
      cityTag: city.tag,
      ...paramsForDefaultPage,
    };
    const isDefaultSearch = searchService.isDefaultSearch({
      ...getListingParams,
      sortKey: getListingParams.sort?.key,
    });

    getListingParams = {
      ...getListingParams,
      is_star: isDefaultSearch && page === 1 ? 1 : 0,
    };

    if (!_.isEqual(this.listingRef.current, getListingParams)) {
      this.setState({ downloadingItems: true });
      this.listingRef.current = getListingParams;
      this.props.history.push(this.prepareUrlForHistory());
      window.scrollTo({ top: 0, behavior: "smooth" });
      try {
        // first request – wait for full body
        const searchResult = await searchService.getAvailableListings(
          getListingParams
        );

        if (isDefaultSearch) {
          localStorage.setItem(settings.isDefaulSearch, isDefaultSearch);
        } else {
          localStorage.removeItem(settings.isDefaulSearch);
        }
        if (isDefaultSearch && getListingParams.page === 1) {
          localStorage.setItem(
            settings.defaultStarProperties,
            searchResult.count
          );
        }

        const firstPagePropertiesCount = isDefaultSearch
          ? localStorage.getItem(settings.defaultStarProperties)
          : settings.actualItemsPerPage;

        this.setState({
          properties: [
            ...this.handleShuffleIfNeeded(
              searchResult.results,
              isDefaultSearch
            ),
          ],
          ...((!isDefaultSearch ||
            (isDefaultSearch && getListingParams.page > 1)) && {
            totalProperties: isDefaultSearch
              ? Number(searchResult.totalItems) + Number(firstPagePropertiesCount)
              : searchResult.totalItems,
          }),
          getListingParams,
        });

        // second request – also awaited
        if (isDefaultSearch && getListingParams.page === 1) {
          const countRes = await searchService.getAvailableListingsCount(
            getListingParams
          );
          this.setState({
            totalProperties:
              Number(countRes.totalItems) +
              Number(localStorage.getItem(settings.defaultStarProperties)),
          });
        }

        if (getMapProperties) {
          const firstPageListForMap =
            isDefaultSearch && getListingParams.page === 1
              ? this.handleShuffleIfNeeded(
                searchResult.results,
                isDefaultSearch
              )
              : null;
          this.getAvailableListingsForMap(getListingParams, {
            firstPageListForMap,
          });
        }
      } catch (err) {
        swal({
          text: this.props.t("common:errorPropertiesData"),
          className: checkForArabic("arabic-modal"),
        });
        this.setState({ downloadingItems: false });
      } finally {
        // loader hides only after everything above is done
        this.setState({ downloadingItems: false });
      }
    }
  };

  getAvailableListingsForMap(params, options = {}) {
    const { firstPageListForMap } = options;
    this.setState({
      downloadingMapItems: true,
    });

    const isDefaultSearch = searchService.isDefaultSearch({
      ...params,
      sortKey: params.sort?.key,
    });

    // For first page default search, modify params to include star properties like list API
    const mapParams = {
      ...params,
      is_star: isDefaultSearch && params.page === 1 ? 1 : 0,
    };

    searchService
      .getAvailableListingsForMap(mapParams)
      .then((result) => {
        let mapProperties = [...(result.results || [])];
        if (
          firstPageListForMap?.length &&
          isDefaultSearch &&
          params.page === 1
        ) {
          mapProperties = this.mergeFirstPageListIntoMapProperties(
            mapProperties,
            firstPageListForMap
          );
        }
        this.setState({
          mapProperties,
        });
      })
      .finally(() => {
        this.setState({ downloadingItems: false, downloadingMapItems: false });
      });
  }

  prepareUrlForHistory() {
    return generateSearchLink(
      this.state.city.urlName,
      this.state.startDate,
      this.state.endDate,
      this.state.guests,
      this.state.sortMethod?.translationKey,
      this.state.page,
      this.state.tags,
      this.state.bedrooms,
      this.state.searchText
    );
  }

  searchByNameToggle() {
    this.setState({ searchByNameVisible: !this.state.searchByNameVisible });
  }

  submitSearchText(event) {
    this.searchByNameToggle();
    this.onSearchClick();
    event.preventDefault();
  }

  resetFreeText() {
    this.setState({ searchText: "" }, () => {
      this.searchByNameToggle();
      this.onSearchClick();
    });
  }

  handleTagLinkClick(event, tag) {
    event.preventDefault();
    const tagSlug = getReplacedTag(tag);
    this.setState(
      {
        page: 1,
        bedrooms: [],
        guests: 1,
        searchText: "",
        endDate: null,
        startDate: null,
      },
      () => {
        this.props.history.push(`/${this.state.city.urlName}/${tagSlug}`);
      }
    );
  }

  renderBottomtagLinks(tagsArray) {
    return (
      <div className="city-area">
        {tagsArray.map((tag, index) => (
          <div className="linkContainer" key={index}>
            <Link
              onClick={(event) => this.handleTagLinkClick(event, tag)}
              className="tagLink rental-guide-detail"
              key={tag.slug}
              to={`/${this.state.city.urlName}/${getReplacedTag(tag)}`}
            >
              {this.props.t(tag.translationKey)}
            </Link>
            {tagsArray?.length !== index + 1 && (
              <div className="links__divider"></div>
            )}
          </div>
        ))}
      </div>
    );
  }

  getMetaAreaKey() {
    const { paramValue } = this.props.match.params;
    if (!paramValue) return this.state.city?.urlName;
    const firstSlug = paramValue.split(",")[0];
    return checkAreaMatchesForDescription(firstSlug, this.state.city?.urlName);
  }

  renderMetaTile() {
    const key = this.getMetaAreaKey();
    return this.props.t(`short_desc:${key}MetaTitle`);
  }

  renderMetaDescription() {
    const key = this.getMetaAreaKey();
    return settings.metaDescriptions[`${key}MetaDescription`];
  }

  render() {
    const { paramValue } = this.props.match.params;

    // remove area tags with coma separated
    const { pathname } = window.location;
    const location = pathname.substring(0, pathname.lastIndexOf("/"));
    const canonicalURL = `${
      paramValue ? `${location}/${paramValue.split(",")[0]}` : pathname
    }`;

    return (
      <div className="search-home search-top-bar">
        <Helmet>
          <title>{this.renderMetaTile()}</title>
          <link
            rel="canonical"
            href={`${process.env.REACT_APP_BASE_URL}${canonicalURL}`}
          />
          <meta name="description" content={this.renderMetaDescription()} />
        </Helmet>
        <div className="search-bar">
          <SearchBar
            state={this.state}
            cities={this.state.cities.filter(({ visible }) => visible)}
            tags={this.state.tags}
            bedrooms={this.state.bedrooms}
            onChangeHandler={this.onChangeHandler.bind(this)}
            onCityClick={this.onCityClick.bind(this)}
            onTagsChange={this.onTagsChange.bind(this)}
            onBedroomsChange={this.onBedroomsChange.bind(this)}
            onGuestChange={this.onGuestChange.bind(this)}
            onDatesChange={this.onDatesChange.bind(this)}
            onSearchClick={this.onSearchClickEvent.bind(this)}
          />
        </div>
        <div className="review-container">
          <TrustPilot2 />
        </div>
        <SearchResult
          {...this.props}
          searchByNameToggle={this.searchByNameToggle.bind(this)}
          downloadingItems={this.state.downloadingItems}
          downloadingMapItems={this.state.downloadingMapItems}
          onDropdownClick={this.onSortSelect.bind(this)}
          onChangePage={this.onChangePage.bind(this)}
          onChangeHandler={this.onChangeHandler.bind(this)}
          state={this.state}
          properties={this.state.properties}
          mapProperties={this.state.mapProperties}
          totalProperties={this.state.totalProperties}
          selectedPage={this.state.page}
          getListingParams={this.state.getListingParams}
          checkIn={this.state.startDate}
          checkOut={this.state.endDate}
          guests={this.state.guests}
        />
        <ShortDescription
          city={this.state.city}
          tags={paramValue}
          t={this.props.t}
          renderBottomtagLinks={this.renderBottomtagLinks.bind(this)}
        />
      </div>
    );
  }
}

export default withTranslation("search")(Search);
